import type { ContainerType } from "~/container";
import type { IApi } from "~/interfaces/IApi";
import type { IReportCategoryService } from "@saif-reporting/domain/interfaces/services/IReportCategoryService.js";
import type { ReportCategoryDto } from "@saif-reporting/domain/dtos/models/ReportCategoryDto.js";

export class ReportCategoryService implements IReportCategoryService {
  private readonly api: IApi;
  constructor({ baseApi }: ContainerType) {
    this.api = baseApi;
  }

  async getList(): Promise<ReportCategoryDto[]> {
    return await this.api.$fetch<ReportCategoryDto[]>("/report-categories");
  }
}
